const formatDate = (isoDate: string) =>
  isoDate
    .split('-')
    .reverse()
    .join('/');

export default formatDate;
